<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click="onClick">
    <img src="~@/assets/img/CITEditor/bold.svg" alt="bold" title="bold" />
  </button>
</template>

<script>
export default {
  name: 'Bold',
  props: [
    'active',
    'tag'
  ],
  methods: {
    onClick () {
      document.execCommand('Bold', false)
      setTimeout(() => {
        const active = this.checkTag()
        this.$emit('setActive', { name: 'Bold', active: active })
        // this.convertElement()
      })
    },
    checkTag () {
      const selection = window.getSelection()
      const nodeName = selection.focusNode.parentNode.nodeName.toLowerCase()
      const isActive = this.tag.includes(nodeName)
      return isActive
    },
    // convert ELEMENT strike to s
    convertElement () {
      const citEditor = document.querySelectorAll('.citContents')
      if (citEditor.length > 0) {
        citEditor.forEach(function (x) {
          const btags = x.querySelectorAll('b')
          if (btags.length > 0) {
            btags.forEach(function (b) {
              const strong = document.createElement('strong')
              strong.innerHTML = b.innerHTML
              b.replaceWith(strong)
            })
          }
        })
      }
    }
  }
}
</script>
